import * as moment from 'moment';

export class Payment {
	paymentDate: moment.Moment;
	paymentAmount;
	paymentMethodType;
	paymentMethodAccount;
	allowCancel: boolean = false;

	constructor(
		public plan,
		public accountName,
		public accountId,
		instrument,
		plannedPayment,
		portfolioSettings,
		public contactName
	) {
		this.paymentDate = moment(plannedPayment.paymentDate);
		this.paymentAmount = plannedPayment.paymentAmount;
		this.paymentMethodType = instrument.paymentType;
		this.paymentMethodAccount = instrument.paymentAccount;
		if (portfolioSettings && portfolioSettings.settings && portfolioSettings.settings.paymentTypes) {
			this.allowCancel = portfolioSettings.settings.paymentTypes.allowConsumersToCancelSingleFutureOnPortal || false;
		}
	}
}

